<div class="modal-header">
    <h4 class="modal-title">{{ 'Validation Warning' | translate }}</h4>
    <button class="close" type="button" aria-label="Close" (click)="activeModal.close(null)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <p>
        <fa-icon class="mr-1 text-warning" [icon]="['fas', 'exclamation-triangle']"></fa-icon>
        {{
            'The following Cargo Manifest Items already have been announced on an existing Service Request.' | translate
        }}
    </p>
    <table class="table table-stripped table-bordered mt-2">
        <thead>
            <tr>
                <th>{{ 'CMI Seq No' | translate }}</th>
                <th>{{ 'B/L Number' | translate }}</th>
                <th>{{ 'Existing SR ID' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            @for (row of duplicates; track row) {
                <tr>
                    <td>{{ row.sequenceNbr }}</td>
                    <td>{{ row.billOfLadingNbr }}</td>
                    <td>{{ row.serviceRequestId }}</td>
                </tr>
            }
        </tbody>
    </table>
</div>
<div class="modal-footer">
    <button class="btn btn-sm btn-primary" preventMultiClick (click)="activeModal.close(true)">
        {{ 'Confirm / Proceed' | translate }}
    </button>
    <button class="btn btn-sm btn-secondary" (click)="activeModal.close(null)">
        {{ 'Cancel' | translate }}
    </button>
</div>
